import { array, object, string } from "yup";

export const MerchantDetailsSchema = object({
  merchant_details: array().of(
    object().shape({
      email: string()
        .required("Email is required")
        .email("Invalid email format"),
      merchant_id: string(),
    })
  ),
});
